import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { ImageOff } from 'lucide-react';
import styles from './ImageWithFallback.module.scss';
import { getInitials } from './Avatar';

const ImageWithFallback = ({ src, alt = '', name, className, ...props }) => {
  const [failed, setFailed] = useState(!src);

  useEffect(() => setFailed(!src), [src]);

  if (failed) {
    return (
      <div className={clsx(styles.fallback, className)} role="img" aria-label={alt || name || 'Image unavailable'} {...props}>
        <span className={styles.mark}>{getInitials(name)}</span>
        <ImageOff size={18} aria-hidden="true" />
      </div>
    );
  }

  return <img src={src} alt={alt} className={clsx(styles.image, className)} onError={() => setFailed(true)} {...props} />;
};

export default ImageWithFallback;
